<template>
  <div class="d-flex flex-wrap align-center ga-2" role="search">
    <v-text-field
      :model-value="modelValue.search"
      @update:model-value="setSearch"
      label="Search recipes"
      prepend-inner-icon="mdi-magnify"
      variant="outlined"
      density="compact"
      hide-details
      clearable
      class="search"
    />
    <v-select
      :model-value="modelValue.sort"
      @update:model-value="setSort"
      :items="sorts"
      label="Sort by"
      variant="outlined"
      density="compact"
      hide-details
      class="sort"
    />
    <v-btn
      :prepend-icon="
        modelValue.favoritesOnly ? 'mdi-heart' : 'mdi-heart-outline'
      "
      :variant="modelValue.favoritesOnly ? 'tonal' : 'text'"
      :aria-pressed="modelValue.favoritesOnly"
      @click="update({ favoritesOnly: !modelValue.favoritesOnly })"
    >
      Favourites
    </v-btn>
    <v-chip-group
      v-if="tags.length"
      :model-value="modelValue.tags"
      @update:model-value="setTags"
      multiple
      filter
      column
      aria-label="Tags"
      class="w-100"
    >
      <v-chip v-for="tag in tags" :key="tag" :value="tag">
        {{ tag }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script lang="ts">
  import { defineComponent, type PropType } from 'vue';
  import type { RecipeFilter, RecipeSort } from '@/service/recipe/findRecipes';

  const sorts: { title: string; value: RecipeSort }[] = [
    { title: 'Recently added', value: 'recent' },
    { title: 'Title', value: 'title' },
    { title: 'Rating', value: 'rating' },
    { title: 'Preparation time', value: 'preparationTime' },
  ];

  export default defineComponent({
    name: 'RecipeFilters',
    props: {
      modelValue: {
        type: Object as PropType<RecipeFilter>,
        required: true,
      },
      // Every tag in use, to filter by
      tags: {
        type: Array as PropType<string[]>,
        default: () => [],
      },
    },
    emits: {
      'update:modelValue': (_filter: RecipeFilter) => true,
    },
    setup(props, { emit }) {
      function update(changes: Partial<RecipeFilter>) {
        emit('update:modelValue', { ...props.modelValue, ...changes });
      }

      return {
        sorts,
        update,
        setSearch(search: string | null) {
          update({ search: search ?? '' });
        },
        setSort(sort: RecipeSort) {
          update({ sort });
        },
        setTags(tags: string[]) {
          update({ tags });
        },
      };
    },
  });
</script>

<style scoped>
  .search {
    flex: 1 1 200px;
  }

  .sort {
    flex: 0 1 200px;
  }
</style>
